module.exports = __webpack_public_path__ + "img/6.74895794.gif";